export enum MessageType {
    message = 1,
    note = 2,
}